<template>
  <app-wrapper :colorBg="bgColor">
    <transition
      :name="'fade'"
      mode="out-in"
      :duration="{ enter: 250, leave: 250 }"
    >
      <loading v-if="!siteLoaded"/>
    </transition>
    <transition
      :name="'fade'"
      mode="out-in"
      :duration="{ enter: 250, leave: 250 }"
    >
      <article class="content-wrapper" v-if="siteLoaded">
        <slot></slot>
      </article>
    </transition>
  </app-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'
import { heights, colors } from '@/styles/theme'
import Loading from '@/views/Loading'

const props = {
  colorBg: String
}

const AppWrapper = styled('main', props)`
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 350ms ease-in-out;
  backface-visibility: hidden;
  perspective: 1000;
  background-color: ${props => props.colorBg || colors.white};
  will-change: all;
  overflow-y: visible;
  .content-wrapper {
    ${_.flexColumn};
    width: 100%;
    min-height: calc(100vh - ${heights.header});
    transition: opacity 1350ms ease-in-out;
    &.fade-enter {
      opacity: 0;
      transform: scale(1.125);
    }
    &.fade-leave-active {
      opacity: 0;
      transform: scale(1.5);
    }
    &:before {
      content: '';
      width: 100%;
      height: 1rem;
      position: absolute;
      left: 0;
      z-index: 1000;
      background-color: ${colors.black};
    }
    &:before {
      top: 0;
      transform: translateY(-1rem);
    }
  }
`

export default {
  components: {
    AppWrapper,
    Loading
  },
  props: [
    'bgColor'
  ],
  data () {
    return {
      wh: window.innerHeight
    }
  },
  computed: {
    ...mapState([
      'siteLoaded'
    ])
  }
}
</script>
